import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiFileText, FiCreditCard } from 'react-icons/fi';
import FormLayout, { SubmitBtn } from '../../ui/FormLayout';
import { InputField, CheckField } from '../../ui/InputField';

const AlterarFormaPagamento = () => {
    const [parcelamento, setParcelamento] = useState(false);
    const [descricao, setDescricao] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const parametro = useParams();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    useEffect(() => {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id })
        };
        fetch(Apis.urlListarOneFormaPagamento, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    setDescricao(result.registros[0].descricao);
                    setParcelamento(result.registros[0].parcelamento === '0' ? false : true);
                } else {
                    alertaErro(result.retorno.mensagem);
                    navigate("/listar-forma-pagamento");
                }
                setLoading(false);
            });
    }, []);

    const handleSubmit = () => {
        if (descricao !== '') {
            setLoading(true);
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
                body: JSON.stringify({ "id": parametro.id, "descricao": descricao, "parcelamento": parcelamento === true ? 1 : 0 })
            };
            fetch(Apis.urlAlterarFormaPagamento, requestOptions)
                .then(response => response.json())
                .then((result) => {
                    if (result.retorno.sucesso) {
                        navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-forma-pagamento`);
                    } else {
                        alertaErro(result.retorno.mensagem);
                    }
                    setLoading(false);
                });
        } else {
            alertaErro('O campo descrição é obrigatório.');
        }
    };

    if (loading) return <Loading />;

    return (
        <FormLayout
            title="Alteração de Forma de Pagamento"
            icon={<FiCreditCard />}
            subtitle="Atualize os dados da forma de pagamento."
        >
            <InputField
                label="Descrição" icon={<FiFileText />} required
                placeholder="Ex: Dinheiro, Cartão de Crédito"
                onChange={e => setDescricao(e.target.value)} value={descricao}
            />
            <CheckField
                label="Permitir Parcelamento no Pedido"
                checked={parcelamento}
                onChange={setParcelamento}
            />
            <SubmitBtn onClick={handleSubmit}>Salvar Alterações</SubmitBtn>
        </FormLayout>
    );
};

export default AlterarFormaPagamento;
